import { Link } from "react-router-dom";
import { getBrandName } from "@/lib/brand";
import { useBrandAsset } from "@/lib/hooks/use-brand-asset";
import { useT } from "@/lib/i18n";
import { DEFAULT_CLIENT_ROUTE } from "@/lib/navigation";

/** Logo and the optional image to the right of it are per-domain overrides (`public/brand/<slug>/logo|badge.{svg,png}`); the bare accent-coloured icon from `public/logo.svg` (drawn through a CSS mask) is the fallback for every domain without one. */
export function Brand({ to = DEFAULT_CLIENT_ROUTE }: { to?: string }) {
  const t = useT();
  const name = getBrandName();
  const logo = useBrandAsset("logo");
  const badge = useBrandAsset("badge");
  return (
    <Link viewTransition to={to} className="brand" aria-label={t("common.brand_home", { name })}>
      {logo
        ? <span className="brand__mark" aria-hidden="true"><img src={logo} alt="" className="brand__mark-image" /></span>
        : <span className="brand__icon" aria-hidden="true" />}
      <span className="brand__name">{name.toUpperCase()}</span>
      {badge ? <img src={badge} alt="" className="brand__badge" aria-hidden="true" /> : null}
    </Link>
  );
}
